import React from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { AiContentItem } from "./AiContentItem";
import { ContentItem } from ".";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

const CarouselContainer = styled.div`
  width: 100%;
  position: relative;

  .swiper {
    width: 100%;
    padding-bottom: 32px;
  }

  .swiper-slide {
    height: auto;
  }

  .swiper-pagination {
    bottom: 0;
  }

  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    background: #DEDEE3;
    opacity: 1;
    transition: all 0.2s ease;
  }

  .swiper-pagination-bullet-active {
    background: #4A4D5E;
    width: 24px;
    border-radius: 4px;
  }
`;

const SlideContent = styled.div`
  padding: 0 4px;
`;

const CarouselCounter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #6B6B76;
  margin-bottom: 8px;
`;

const CounterCurrent = styled.span`
  font-weight: 600;
  color: #4A4D5E;
`;

interface ContentItemsCarouselProps {
  items: ContentItem[];
  "data-testid"?: string;
}

export function ContentItemsCarousel({
  items,
  "data-testid": testId,
}: ContentItemsCarouselProps) {
  const [activeIndex, setActiveIndex] = React.useState(0);

  if (items.length === 0) {
    return null;
  }

  // If only one item, don't show carousel UI
  if (items.length === 1) {
    return (
      <div data-testid={testId || "ContentItemsCarousel"}>
        <AiContentItem
          content={items[0].content}
          videoUrl={items[0].videoUrl}
          videoTitle={items[0].videoTitle}
          isAiPrompt={items[0].isAiPrompt}
          index={0}
        />
      </div>
    );
  }

  return (
    <CarouselContainer data-testid={testId || "ContentItemsCarousel"}>
      <CarouselCounter>
        <CounterCurrent>{activeIndex + 1}</CounterCurrent>
        <span>/</span>
        <span>{items.length}</span>
      </CarouselCounter>
      <Swiper
        modules={[Pagination]}
        pagination={{ clickable: true }}
        spaceBetween={16}
        slidesPerView={1}
        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
      >
        {items.map((item, index) => (
          <SwiperSlide key={index}>
            <SlideContent>
              <AiContentItem
                content={item.content}
                videoUrl={item.videoUrl}
                videoTitle={item.videoTitle}
                isAiPrompt={item.isAiPrompt}
                index={index}
              />
            </SlideContent>
          </SwiperSlide>
        ))}
      </Swiper>
    </CarouselContainer>
  );
}
